export default __webpack_public_path__ + "static/media/background.fd45a5da.jpg";